<template>
  <div>
    <b-card no-body>
      <b-card-body class="p-4">
        <b-form>
          <h1>Almost There!</h1>
          <!--<p class="text-muted">Congratulations your account was created!</p>-->
          <p class="text-muted">A verification code was emailed to you. Once your account is verified you can login.</p>
          <p class="alert alert-warning" v-if="error">{{ error }}</p>
          <p class="alert alert-success" v-if="success">{{ success }}</p>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text>Email</b-input-group-text>
            </b-input-group-prepend>
            
            <b-form-input
              type="text"
              class="form-control"
              placeholder="Email"
              autocomplete="username"
              v-model="$v.username.$model"
              :state="$v.username.$dirty ? !$v.username.$invalid : null"
            />
            <b-form-invalid-feedback>
              Required
            </b-form-invalid-feedback>
          </b-input-group>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text>Code</b-input-group-text>
            </b-input-group-prepend>
            
            <b-form-input
              type="text"
              class="form-control"
              placeholder="Code"
              autocomplete="code"
              v-model="$v.code.$model"
              :state="$v.code.$dirty ? !$v.code.$invalid : null"
            />

            <b-form-invalid-feedback>
              Required
            </b-form-invalid-feedback>
          </b-input-group>
          <b-row>
            <b-col><b-button variant="primary" block @click="resendCode">Re-send Verification Code</b-button></b-col>
            <b-col>
              <b-button variant="success" block @click="applyCode" :disabled="isConfirming">
                <span v-if="isConfirming">
                  <i class="fa fa-circle-notch fa-spin" />
                </span>
                <span v-else>Confirm</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { AUTH_RESEND_CONFIMATION, AUTH_CONFIRMATION } from '@/store/action-types';
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ConfirmationForm',
  props: {
    setEmail: {
      type: String,
      required: true
    },
    setCode: {
      type: String,
      required: true
    }
  },
  mixins: [validationMixin],
  data() {
    return {
      username: this.setEmail || (this.$store.getters.getAuthEmail || null),
      code: this.setCode || null,
      error: null,
      success: null,
      isConfirming: false
    }
  },
  validations: {
    username: { required },
    code: { required }
  },
  mounted() {
    if (this.setEmail && this.setCode) {
      this.applyCode();
    }
  },
  methods: {

    applyCode: function () {
      this.$v.$touch()
      if (this.$v.$dirty && this.$v.$invalid) return

      this.isConfirming = true

      let username = this.username;
      let code = this.code;

      return this.$store.dispatch(AUTH_CONFIRMATION, { username, code }).then(data => {
        this.$emit('onUserConfirmed');
        this.isConfirming = false
      }).catch(err => {
        this.isConfirming = false
        const error = this.$store.getters.getAuthenticationError;
        if (error) {
          this.error = error
        } else {
          this.error = 'Something went wrong please contact an administrator';
        }
      });
    },
    resendCode: function () {

      let username = this.username;

      return this.$store.dispatch(AUTH_RESEND_CONFIMATION, { username }).then(data => {
        const status = this.$store.getters.getAuthenticationStatus;
        if (status === 'confirmation__success') {
          this.$emit('onUserConfirmed');
        } else if (status === 'confirmation__resent') {
          this.success = 'Verification code was re-sent';
        } else {
          this.error = 'Something went wrong please contact an administrator';
        }
      }).catch(err => {
        const error = this.$store.getters.getAuthenticationError;
        if (error) {
          this.error = error
        } else {
          this.error = 'Something went wrong please contact an administrator';
        }
      });

    }
  },
  // async beforeCreate() {
  //   if(!this.$store.getters.getAuthenticatedUsername) {
  //     this.$router.push('/register');
  //   }
  // }
}
</script>
